import { useMemo } from 'react';
import inputTypeStore from '@/components/input-file/input-type';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import InputFile from '../input-file/InputFile';
import { ACCEPT_IMG_TYPE } from '../input-file/shared';
import { HelpOther } from '@/common/helper';
import userStore from '@/store/user';
import globalStore from '@/store/global';
import { useLocation } from 'react-router-dom';
import { isNil } from 'lodash-es';

const MAX_IMG_SIZE = 200
const MAX_FILE_COUNT = 100

function UploadImg({ children, disable }) {
  const location = useLocation();  // 仅AI搜索不支持多图
  const multiple = useMemo(() => {
    // 优先用如果 is_super_aiso 不存在则用 is_aiso
    const isSuperSo = isNil(globalStore.is_super_aiso) ? globalStore.is_aiso : globalStore.is_super_aiso
    let out = true
    if (globalStore.isAiso() && !isSuperSo) {
      out = false
    } else if (!globalStore.isAiso() || globalStore.isAgentPage() || globalStore.isChatPage()) {
      out = true
    }
    console.info('uploadImg support multiple: ', out)
    return out
  }, [location, globalStore.is_aiso, globalStore.is_super_aiso])

  if (disable || !userStore.isUser) {
    return children;
  }

  return (
    <InputFile

      multiple={multiple}
      accept={ACCEPT_IMG_TYPE.join(',')}
      onChange={event => {
        let files = event.target.files;
        if (!files || !files.length) return;

        if (files.length > MAX_FILE_COUNT) {
          HelpOther.toast(`最多只能上传 ${MAX_FILE_COUNT} 张图片`, 'info')
          files = files.slice(0, MAX_FILE_COUNT)
        }

        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const fileType = file.name.slice(file.name.lastIndexOf('.'));
          if (file.size > 1024 * 1024 * MAX_IMG_SIZE) {
            HelpOther.toast(`图片大小不能超过 ${MAX_IMG_SIZE}MB`, 'info');
            return false;
          }
          if (!ACCEPT_IMG_TYPE.includes(fileType.toLocaleLowerCase())) {
            HelpOther.toast(`不支持的文件类型`, 'info');
            return;
          }
        }
        try {
          runInAction(() => {
            inputTypeStore.updateTempData('tempFile', files);
          });
        } finally {
        }
      }}
    >
      {children}
    </InputFile>
  );
}

export default observer(UploadImg);
